export default class FormDataSourceGroupArg
{
	remoteClass = "gongqi.erp.gotmodel.form.datasource.FormDataSourceGroupArg";

	argType;	//int
	groupAlias;	//String
	aliasList;	//ArrayList
	arg;	//Object
	recordCounts;	//int
}


// WEBPACK FOOTER //
// ./src/forms/sys/datasource/FormDataSourceGroupArg.js